import React from "react";
import bpiLogo from "../assets/images/bpi.png";
import bpismsLogo from "../assets/images/bpims.png";
import origamiSwan from "../assets/images/origam.png";
import origamiUmbrella from "../assets/images/origami.png";
import polLeft from "../assets/images/pol-1.png";
import polRight from "../assets/images/pol-2.png";

const Footer = () => {
  return (
    <div
      id="contact-us"
      className="relative flex flex-col justify-center items-center py-4 mb-11 mt-11 overflow-hidden"
    >
      <div className="flex flex-wrap justify-center items-center space-x-6">
        <img
          src={bpiLogo}
          alt="Image 1"
          className="w-24 mx-6 sm:w-28 md:w-32 lg:w-36"
        />
        <img
          src={bpismsLogo}
          alt="Image 2"
          className="w-24 mx-6 sm:w-28 md:w-32 lg:w-36 transform scale-105 transition-all duration-300 hover:scale-110"
        />
      </div>

      <p className="text-center w-full sm:w-3/4 md:w-1/2 lg:w-2/3 text-base font-medium text-gray-500 my-5">
        Powered by BPI/MS Insurance Corporation, a joint venture between the{" "}
        <br />
        Bank of the Philippines Islands and Mitsui Sumitomo Insurance
        Corporation of Japan
      </p>
      <p className="text-center w-full sm:w-3/4 md:w-1/2 lg:w-2/3 text-base font-bold text-gray-500 mb-3">
        Policy terms and conditions apply.
      </p>
      <p className="text-center w-full sm:w-3/4 md:w-1/2 lg:w-2/3 text-base font-medium text-gray-500">
        BPI/MS Insurance Corporation's products are non-life insurance products
        and are not deposit <br />
        products of Bank of the Philippines Islands. These products are not
        covered by the Philippine Deposit <br />
        Insurance Corporation.
      </p>
      <p className="text-center w-full sm:w-3/4 md:w-1/2 lg:w-2/3 text-base font-medium text-gray-500">
        11th, 14th, 16th & 18th Floors, 6811 BPI AIA Makati
        Ayala Avenue Salcedo Village, <br/> Bel-Air 1209 City of Makati NCR, Fourth District Philippines
      </p>
      <p className="text-center w-full sm:w-3/4 md:w-1/2 lg:w-2/3 text-base font-medium text-gray-500 my-3">
        For concerns, you may call BPI MS at (02) 8840-9000 or send an e-mail to
        helpline@bpims.com. <br />
        Our representatives will be glad to assist you.
      </p>
      <p className="text-center w-full sm:w-3/4 md:w-1/2 lg:w-2/3 text-base font-medium text-gray-500 my-3">
        BPI/MS Insurance Corporation is regulated by the Insurance Commission
        (IC).
        <br />
        For more details, visit https://www.insurance.gov.ph.
      </p>
      <p className="text-center w-full sm:w-3/4 md:w-1/2 lg:w-2/3 text-base font-medium text-gray-500 my-3">
        IC Public Assistance Office contact details: <br />
        Landline: (02) 8523-8561 loc. 103/127 <br />
        SMS: 09171160007 or 09999930637 <br />
        E-mail: publicassistance@insurance.com.ph <br />
        Offices: https://www.insurance.gov.ph/contact-us
      </p>

      <div className="absolute -left-[40px] bottom-0">
        <img
          src={polLeft}
          alt="Left polygon background"
          className="w-48 h-48 sm:w-60 sm:h-60 md:w-72 md:h-72 object-contain"
        />
        <img
          src={origamiSwan}
          alt="Origami Swan"
          className="absolute left-8 sm:left-12 md:left-16 bottom-10 sm:bottom-16 md:bottom-20 w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 object-contain -rotate-11"
        />
      </div>

      <div className="absolute -right-[50px] bottom-0">
        <img
          src={polRight}
          alt="Right polygon background"
          className="w-48 h-48 sm:w-60 sm:h-60 md:w-72 md:h-72 object-contain"
        />
        <img
          src={origamiUmbrella}
          alt="Origami Umbrella"
          className="absolute right-8 sm:right-12 md:right-16 bottom-8 sm:bottom-12 md:bottom-16 w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 object-contain rotate-12"
        />
      </div>
    </div>
  );
};

export default Footer;
